module.exports = __webpack_public_path__ + "img/notice-v1-crop.0b3e8309.jpg";